var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11v6m0-6V8a3 3 0 013-3h12a3 3 0 013 3v3M5 11h18m0 0v6M5 17v3a3 3 0 003 3h12a3 3 0 003-3v-3M5 17h18",
    stroke: "#2C2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMTFWMTRWMTdNNSAxMVY4QzUgNi4zNDMxNSA2LjM0MzE1IDUgOCA1SDE0SDIwQzIxLjY1NjkgNSAyMyA2LjM0MzE1IDIzIDhWMTFNNSAxMUgyM00yMyAxMVYxNFYxN001IDE3VjIwQzUgMjEuNjU2OSA2LjM0MzE1IDIzIDggMjNIMTRIMjBDMjEuNjU2OSAyMyAyMyAyMS42NTY5IDIzIDIwVjE3TTUgMTdIMjMiIHN0cm9rZT0iIzJDMkQyRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgList as ReactComponent };